var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"button-box button primary",attrs:{"href":_vm.pathToCitizen}},[_vm._v("Перейти к профилю гражданина")])])}
var staticRenderFns = []

export { render, staticRenderFns }